export enum UrlFilenameEnum {
  json = '.json',
  ico = '.ico'
}
export type UrlFilenameEnumType = keyof typeof UrlFilenameEnum;
